import { toRaw } from "vue"

export const errorPrettifier = (error) => {
  if (error?.data?.errors) {
    const updateScheduleMutatorErr: string[] = Object.values(
      toRaw(error?.data?.errors),
    )
    return updateScheduleMutatorErr
      .flat()
      .map((message) => {
        try {
          const messageJson = JSON.parse(message)
          return (
            messageJson?.errorDescription?.charAt(0).toUpperCase() +
            messageJson?.errorDescription?.slice(1)
          )
        } catch (error) {
          return message?.charAt(0).toUpperCase() + message.slice(1)
        }
      })
      .join(",\n")
  }
  return null
}
